import React from 'react';
import PropTypes from 'prop-types';
import { Container, Content, Label } from './style';

function DesktopItem({ className, content, label, weight = 'bold' }) {
  return (
    <Container className={className}>
      {label ? (
        <Label $weight={weight}>{label}</Label>
      ) : (
        <Content $weight='normal' title={content}>
          {content || '-'}
        </Content>
      )}
    </Container>
  );
}

DesktopItem.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  label: PropTypes.string,
  weight: PropTypes.oneOf(['bold', 'normal', 'light'])
};

export default DesktopItem;
